import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-657af5dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "confirm-wrapper mb-6 p-4" }
const _hoisted_3 = { class: "request" }
const _hoisted_4 = { class: "reset" }
const _hoisted_5 = { class: "confirm" }

type Emits = {
  (event: 'on-confirm'): void
  (event: 'on-reset'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmPermissionChanges',
  emits: ["on-confirm", "on-reset"],
  setup(__props, { emit: __emit }) {

const emits = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('app.controller_permissions.confirm_changes_request')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "button is-text is-fullwidth",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('on-reset')))
        }, _toDisplayString(_ctx.$t('app.controller_permissions.reset')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "is-fullwidth btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('on-confirm')))
        }, _toDisplayString(_ctx.$t('app.controller_permissions.confirm_changes')), 1 /* TEXT */)
      ])
    ])
  ]))
}
}

})